import { siteInfo } from "@/mocks/site";
import {
  buildWhatsAppLink,
  INSTAGRAM_LINK,
  MAPS_DIRECTIONS_LINK,
  MAPS_EMBED_SRC,
  TEL_LINK,
} from "@/utils/whatsapp";
import Reveal from "./Reveal";

export default function Contact() {
  return (
    <section id="iletisim" className="ivory-canvas bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-6">
        <Reveal>
          <div className="flex flex-col items-start gap-4">
            <span className="inline-flex items-center gap-3 font-label text-[0.7rem] font-medium uppercase tracking-[0.32em] text-accent-600">
              <span className="h-px w-8 bg-accent-500/70" aria-hidden="true" />
              İletişim
            </span>
            <h2 className="font-heading text-3xl font-semibold leading-[1.14] tracking-tight text-foreground-950 md:text-[2.6rem]">
              Randevunuzu Planlayın
            </h2>
            <p className="max-w-2xl font-body text-sm leading-relaxed text-foreground-700 md:text-base">
              Size uygun gün ve saat için bize ulaşın. WhatsApp üzerinden hızlıca yanıtlıyoruz.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
          <Reveal className="flex flex-col gap-4">
            <a
              href={TEL_LINK}
              className="flex items-start gap-4 rounded-xl border border-background-300/70 bg-background-50 p-5 transition-colors hover:border-accent-400 md:p-6"
            >
              <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-accent-400/60 bg-primary-50">
                <i className="ri-phone-line text-xl text-primary-600" aria-hidden="true" />
              </span>
              <span className="flex flex-col">
                <span className="font-label text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-foreground-500">
                  Telefon
                </span>
                <span className="mt-1 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                  {siteInfo.phoneDisplay}
                </span>
              </span>
            </a>

            <a
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-4 rounded-xl border border-background-300/70 bg-background-50 p-5 transition-colors hover:border-accent-400 md:p-6"
            >
              <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-accent-400/60 bg-secondary-50">
                <i className="ri-instagram-line text-xl text-secondary-600" aria-hidden="true" />
              </span>
              <span className="flex flex-col">
                <span className="font-label text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-foreground-500">
                  Instagram
                </span>
                <span className="mt-1 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                  {siteInfo.instagramHandle}
                </span>
              </span>
            </a>

            <div className="flex items-start gap-4 rounded-xl border border-background-300/70 bg-background-50 p-5 md:p-6">
              <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-accent-400/60 bg-accent-50">
                <i className="ri-map-pin-2-line text-xl text-accent-700" aria-hidden="true" />
              </span>
              <address className="flex flex-col not-italic">
                <span className="font-label text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-foreground-500">
                  Adres
                </span>
                <span className="mt-1 font-body text-sm leading-relaxed text-foreground-800 md:text-base">
                  {siteInfo.addressLine1}
                  <br />
                  {siteInfo.addressLine2}
                  <br />
                  {siteInfo.addressLine3}
                </span>
              </address>
            </div>

            <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <a
                href={buildWhatsAppLink(siteInfo.defaultMessage)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-background-50 transition-colors hover:bg-primary-700"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-whatsapp-line text-base" aria-hidden="true" />
                </span>
                WhatsApp’tan Yazın
              </a>
              <a
                href={TEL_LINK}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-primary-700 transition-colors hover:border-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-phone-line text-base" aria-hidden="true" />
                </span>
                Hemen Arayın
              </a>
              <a
                href={MAPS_DIRECTIONS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-400 px-6 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-accent-700 transition-colors hover:bg-accent-500 hover:text-primary-950"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-navigation-line text-base" aria-hidden="true" />
                </span>
                Yol Tarifi Alın
              </a>
            </div>
          </Reveal>

          <Reveal delay={120} className="h-full">
            <div className="h-72 overflow-hidden rounded-xl border border-background-300/70 bg-background-100 sm:h-96 lg:h-full lg:min-h-[26rem]">
              <iframe
                title="Fatma Angay Güzellik Salonu konumu - Osmangazi Bursa"
                src={MAPS_EMBED_SRC}
                className="h-full w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}